function showPopup() {
    const popup = document.getElementById('popup');
    popup.style.display = 'flex';
  }
  
  function closePopup() {
    const popup = document.getElementById('popup');
    popup.style.display = 'none';
  }
  
  function dontShowPopup() {
    const popup = document.getElementById('popup');
    popup.style.display = 'none';
  
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    document.cookie = "hidePopup=true; expires=" + tomorrow.toUTCString() + "; path=/";
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    const cookies = document.cookie.split(';').map(cookie => cookie.trim());
    const hidePopupCookie = cookies.find(cookie => cookie.startsWith('hidePopup='));
  
    if (!hidePopupCookie) {
      showPopup();
    }
  });
  